
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class DomainModel extends Model<DomainModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'metaData', type: 'string' },
		{ name: 'awaitingTaskActionId', type: 'string' },
		{ name: 'pendingAuthId', type: 'string' }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public productPlanId?: string;
	public companyId?: string;
	public created?: Date;
	public deleted?: Date;
	public metaData?: string;
	public awaitingTaskActionId?: string;
	public pendingAuthId?: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.productPlanId = undefined;
		this.companyId = undefined;
		this.created = undefined;
		this.deleted = undefined;
		this.metaData = undefined;
		this.awaitingTaskActionId = undefined;
		this.pendingAuthId = undefined;
		
	}
	getProperties(){
		return DomainModel.classProperties;
	}
}

